/*
 * @description: module中可根据需要配置，此文件最终需要导出一个list对象，framework会加载此文件，不要修改文件路径和名称
 * @author:Vincent
 * @since:
 * @version: 1.0
 */

import routerRegister from './module/register.js'
import routerMain from './module/isp-main.js'
import routerNotice from './module/isp-notice.js'
import routerServiceCenter from './module/service-center.js'
import routerPersonalCenter from './module/personal-center.js'
import routerSupplier from './module/supplier.js'
import routreBid from './module/bid.js'
import registerUploadFile from './module/registerUploadFile.js'
import enroll from './module/enroll.js'
import myBid from "./module/my-bid";
import interfaceDefinition from "./module/interface-definition.js";

// const routers = [...routre1, ...routre2]
const routers = [
  ...routerRegister,
  ...routerMain,
  ...routerNotice,
  ...routerServiceCenter,
  ...routerPersonalCenter,
  ...routerSupplier,
  ...routreBid,
  ...registerUploadFile,
  ...enroll,
  ...myBid,
  ...interfaceDefinition,
]

export default routers

